import { TicketAttachmentMeta } from "@signalist/shared-types";

import { saveFileFromBlob } from "@/pages/Private/pages/Contacts/utils/downloadFile";

/** Mirrors the API's Content-Disposition rule (PREC-3935 decision 4): images and PDFs preview. */
export const isInlineAttachment = (mimeType: string): boolean =>
	mimeType.startsWith("image/") || mimeType === "application/pdf";

/** Long enough for the tab to load the blob; the tab keeps its own reference afterwards. */
const REVOKE_AFTER_MS = 60_000;

/**
 * Hand a fetched attachment to the browser. An inline type goes into `tab` — a window the caller
 * opened **synchronously on the click**, before the authenticated fetch, so popup blockers see a
 * user gesture; everything else is saved through the app's download helper.
 */
export const deliverAttachmentBlob = (
	blob: Blob,
	attachment: TicketAttachmentMeta,
	tab: Window | null
): void => {
	if (tab && isInlineAttachment(attachment.mimeType)) {
		const url = URL.createObjectURL(blob);

		tab.location.href = url;
		setTimeout(() => URL.revokeObjectURL(url), REVOKE_AFTER_MS);

		return;
	}

	void saveFileFromBlob(Promise.resolve(blob), attachment.fileName, {
		description: attachment.fileName,
		mimeType: attachment.mimeType,
		extension: attachment.fileName.split(".").pop() ?? "",
	});
};
